module.exports = __webpack_public_path__ + "img/Approvedlogo.e3658097.png";